import * as React from "react";
import SimpleButton from "../../RenderComponents/SimpleButton";

interface IProps {
    isAdmin: boolean;
    includeDeleted: boolean;
    onClick: () => void;
    className?: string;
    type?: "a" | "button";
    archivedTitle?: string;
    unarchivedTitle?: string;
    archivedAriaLabel?: string;
    unarchivedAriaLabel?: string;
    archivedText?: string;
    unarchivedText?: string;
}

const ShowArchivedButton = (props: IProps) => {
    const archivedText = props.archivedText || "Hide archived";
    const unarchivedText = props.unarchivedText || "Show archived";
    return props.isAdmin ? (
        <SimpleButton
            className={props.className || "CMS_button CMS_bAction"}
            type={props.type}
            title={props.includeDeleted ? props.archivedTitle || "Hide archived" : props.unarchivedTitle || "Show archived"}
            ariaLabel={props.includeDeleted ? props.archivedAriaLabel || "Hide archived" : props.unarchivedAriaLabel || "Show archived"}
            href={"#"}
            onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                props.onClick();
            }}
        >
            {props.includeDeleted ? archivedText : unarchivedText}
        </SimpleButton>
    ) : null;
};

export default ShowArchivedButton;
